import { CommonModule, isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import {
 ChangeDetectionStrategy,
 Component,
 Inject,
 inject,
 InjectionToken,
 Input,
 PLATFORM_ID,
} from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { WINDOW } from '../../search-result.module';
@Component({
 selector: 'iho-plp-map',
 templateUrl: './plp-map.component.html',
 styleUrls: ['./plp-map.component.scss'],
 imports: [CommonModule, NgOptimizedImage, RouterModule],
 changeDetection: ChangeDetectionStrategy.OnPush,
 standalone: true,
})
export class PlpMapComponent {
 @Input() mapUrl? = '';
 @Input() accommodation? = '';
 cdnUrl = cdnUrl;
 router = inject(Router);
 route = inject(ActivatedRoute);
 constructor(
  @Inject(WINDOW) private window: Window,
  @Inject(PLATFORM_ID) private platformId: object
 ) {}
 goToMap() {
  if (isPlatformBrowser(this.platformId)) {
   const baseRoute =
    this.accommodation !== 'ecolodge'
     ? '/' + this.route.snapshot.paramMap.get('city-name')
     : this.window.location.href.split('/')[3] +
       ('/' + decodeURI(window.location.href.split('/')[4].split('?')[0]));
   const queryParams = this.route.snapshot.queryParams;
   this.router.navigate([`${baseRoute}/map`], { queryParams });
  }


}

}
